import { render, staticRenderFns } from "./CreateNewItemInCatalog.vue?vue&type=template&id=22760b62&scoped=true"
import script from "./CreateNewItemInCatalog.vue?vue&type=script&lang=js"
export * from "./CreateNewItemInCatalog.vue?vue&type=script&lang=js"
import style0 from "./CreateNewItemInCatalog.vue?vue&type=style&index=0&id=22760b62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22760b62",
  null
  
)

export default component.exports